export default __webpack_public_path__ + "static/media/PoweredBy_Color.7902e5af.svg";